import React from "react";
import { styled } from '@mui/material/styles';
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

export default function TemplatesModal(props) {

    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
    }));

    return (
        <>
            <BootstrapDialog
                onClose={props.handleCloseModal}
                aria-labelledby="customized-dialog-title"
                open={props.isOpen}
            >
                <DialogTitle id="customized-dialog-title">
                    Previsualización de plantilla
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={props.handleCloseModal}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <div dangerouslySetInnerHTML={{ __html: props.body }} ></div>
                </DialogContent>

            </BootstrapDialog>
        </>
    );
}
